import { render, staticRenderFns } from "./OrderBodyItem.vue?vue&type=template&id=68f0eab4&scoped=true&"
import script from "./OrderBodyItem.vue?vue&type=script&lang=js&"
export * from "./OrderBodyItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderBodyItem.vue?vue&type=style&index=0&id=68f0eab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0eab4",
  null
  
)

export default component.exports